// removed by extract-text-webpack-plugin
module.exports = {"vis-panel":"styles-module__vis-panel___Vbhq1","selected-paper-box":"styles-module__selected-paper-box___3DpEA"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/RightPanel/styles.module.css
// module id = 1072
// module chunks = 0